import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import "./main.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/styles/tailwind.css";

// layouts

import Admin from "layouts/Admin.js";
import Auth from "layouts/Auth.js";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from "react-toastify";

// views without layouts

import Landing from "views/Landing.js";
import Profile from "views/Profile.js";
import PrivateRoute from "route-guards/PrivateRoute";

ReactDOM.render(
  <>
    <BrowserRouter>
      <Switch>
        {/* add routes with layouts */}
        <PrivateRoute path="/admin" component={Admin} />
        <Route path="/auth" component={Auth} />

        {/* add redirect for first page */}
        <Redirect from="*" to="/admin" />
      </Switch>
    </BrowserRouter>
    <ToastContainer position="top-right" draggable newestOnTop />
  </>,
  document.getElementById("root")
);
